/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FindSpotType {
  Placeholder = 'Placeholder',
  Surrounding = 'Surrounding',
  Match = 'Match'
}
